import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import moment from 'moment';
import config from '../../config';
import { SavingPotDatePicker } from './SavingPotDatePicker';
import { BasicModal } from '../common/modals/BasicModal';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import AnalyticsActionCreator from '../../actions/AnalyticsActionCreator';
import AccountsStore from '../../stores/AccountsStore';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import BrowserUtils from '../../utils/BrowserUtils';
import { PotMessages } from './PotMessages';
import LoaderComponent from '../common/LoaderComponent';
import SiteHeaderActionCreator from '../../actions/SiteHeaderActionCreator';

const extract = (str, pattern) => (str.match(pattern) || []).pop() || '';
const extractAlphaNum = (str) => extract(str, '^[A-Za-z0-9 /-]+');
let currentDateFlag = false;

/**
 * @todo
 * The quality of this component is poor.
 * Future work should be undertaken to refactor/remove this component
 * and improve the performance and maintainability of the functionality.
 */
class CreateSavingsPot extends Component {
  constructor(props) {
    super(props);

    this.alertEditErrorModal = this.alertEditErrorModal.bind(this);
    this.alertOnDuplicatePotName = this.alertOnDuplicatePotName.bind(this);
    this.closeAlertModal = this.closeAlertModal.bind(this);
    this.decrement = this.decrement.bind(this);
    this.getAccountNumber = this.getAccountNumber.bind(this);
    this.getCurrentPotPage = this.getCurrentPotPage.bind(this);
    this.getExpectedMonth = this.getExpectedMonth.bind(this);
    this.getExpectedScheduleValue = this.getExpectedScheduleValue.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handlePotBalanceChange = this.handlePotBalanceChange.bind(this);
    this.handlePotGoalBlur = this.handlePotGoalBlur.bind(this);
    this.handlePotGoalChange = this.handlePotGoalChange.bind(this);
    this.handlePotNameChange = this.handlePotNameChange.bind(this);
    this.handlePotScheduleValueBlur =
      this.handlePotScheduleValueBlur.bind(this);
    this.handlePotScheduleValueChange =
      this.handlePotScheduleValueChange.bind(this);
    this.increment = this.increment.bind(this);
    this.onBalanceKeyDown = this.onBalanceKeyDown.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onMonthlyContributionKeyDown =
      this.onMonthlyContributionKeyDown.bind(this);
    this.onPaste = this.onPaste.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkNumber = this.checkNumber.bind(this);
    this.checkNumberForBalance = this.checkNumberForBalance.bind(this);
    this.closeFaq = this.closeFaq.bind(this);
    this.openFaq = this.openFaq.bind(this);

    this.state = {
      pots: {
        name: null,
        goal: {
          amount: {
            value: '£',
            currency: props.content.savingPotCurrencyType,
          },
          when: moment().format('YYYY-MM-DD'),
        },
        schedule: {
          recurrence: {
            frequency: {
              monthly: {
                interval: 1,
                day_of_month: 1,
              },
            },
            amount: {
              value: '£',
              currency: props.content.savingPotCurrencyType,
            },
          },
        },
      },
      potID: null,
      potBalanceValue: '£',
      headerMessage: BrowserUtils.isMobileView()
        ? props.content.savingPotCreateHeadingMobile
        : props.content.savingPotCreateHeading,
      isDisabled: true,
      isCurrentBalanceDisabled: false,
      isDisabledDecrease: true,
      isDisabledSubmit: true,
      isNameDisabled: false,
      accountNumber: this.getAccountNumber(),
      format: 'YYYY-MM-DD',
      inputFormat: 'MMMM YYYY',
      mode: 'years',
      defaultText: props.content.savingPotDateDefaultText,
      isCreatePot: 'fade',
      startMinDate: moment(),
      isDuplicateModal: false,
      errorModal: false,
      isChanged: false,
      isGoalShaked: '',
      isBalanceShaked: '',
      isMonthlyContributionShaked: '',
      potGoalForEditPot: '£',
      potMonthlyContributionForEditPot: '£',
      isLoader: false,
    };
  }

  componentWillMount() {
    BrowserUtils.isMobileView() && SiteHeaderActionCreator.hideHeaderFlag(true);
    currentDateFlag = false;
    let headerInWillMount;
    if (BrowserUtils.isMobileView()) {
      headerInWillMount = this.props.content.savingPotEditHeadingMobile;
    } else {
      headerInWillMount = this.props.content.savingPotEditHeading;
    }
    if (this.props.potDetailsData) {
      currentDateFlag = true;
      this.setState({
        pots: {
          name: this.props.potDetailsData.name,
          goal: {
            amount: {
              value: `£${this.props.potDetailsData.goalAmount}`,
              currency: this.props.potDetailsData.goalAmountCurrency,
            },
            when: this.props.potDetailsData.goalWhen,
          },
          schedule: {
            recurrence: {
              frequency: {
                monthly: {
                  interval: this.props.potDetailsData.interval,
                  day_of_month: this.props.potDetailsData.dayOfMonth,
                },
              },
              amount: {
                value: `£${this.props.potDetailsData.monthlyContry}`,
                currency: this.props.potDetailsData.monthlyContryCurrency,
              },
            },
          },
        },
        potID: this.props.potDetailsData.id,
        potBalanceValue: `£${this.props.potDetailsData.balance}`,
        defaultText: moment(this.props.potDetailsData.goalWhen).format(
          'MMMM YYYY'
        ),
        headerMessage: headerInWillMount,
        isDisabled: false,
        isDisabledDecrease: false,
        isDisabledSubmit: true,
        isNameDisabled: true,
        isCurrentBalanceDisabled: true,
        isChanged: true,
        potGoalForEditPot: this.props.potDetailsData.goalAmount,
        potMonthlyContributionForEditPot:
          this.props.potDetailsData.monthlyContry,
        isLoader: false,
      });
    }
    if (!_.isEmpty(SavingsPotsStore.createPotData())) {
      const potsData = SavingsPotsStore.createPotData();
      const potBalanceStoreValue = SavingsPotsStore.getPotBalanceStoreValue();
      this.setState({
        pots: potsData,
        isCreatePot: 'fade in',
        isDisabledSubmit: false,
        defaultText: moment(potsData.goal.when).format('MMMM YYYY'),
        potBalanceValue: `£${potBalanceStoreValue}`,
        isLoader: false,
        isChanged: true,
      });
    }

    if (!_.isEmpty(this.props.editError)) {
      this.setState({ errorModal: true, isLoader: false });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEmpty(SavingsPotsStore.createPotData())) {
      const potsData = SavingsPotsStore.createPotData();
      const potBalanceStoreValue = SavingsPotsStore.getPotBalanceStoreValue();
      this.setState({
        pots: potsData,
        isCreatePot: 'fade in',
        isDisabledSubmit: false,
        defaultText: moment(potsData.goal.when).format('MMMM YYYY'),
        potBalanceValue: `£${potBalanceStoreValue}`,
        isChanged: true,
      });
    }

    if (!_.isEmpty(nextProps.editError)) {
      this.setState({ errorModal: true, isLoader: false });
    }
  }

  componentWillUnmount() {
    SiteHeaderActionCreator.hideHeaderFlag(false);
  }

  alertEditErrorModal() {
    if (this.state.errorModal) {
      return (
        <BasicModal>
          <div className="modal_content">
            <h3>{this.props.editError.error.message}</h3>
            <p>
              {this.props.content.potSupportMessage1}
              <br />
              {this.props.content.potSupportMessage2}
              <br />
              {this.props.editError.error.quoteId}
            </p>
          </div>
          <div className="modal_footer">
            <button onClick={this.closeAlertModal}>
              {this.props.content.ok}
            </button>
          </div>
        </BasicModal>
      );
    } else {
      return false;
    }
  }

  // Returns the modal for displaying message for editPayment
  alertOnDuplicatePotName() {
    if (this.state.isDuplicateModal) {
      return (
        <BasicModal>
          <div className="modal_content">
            <p>{this.props.content.savingPotModalText1}</p>
          </div>
          <div className="modal_footer">
            <button onClick={this.closeAlertModal}>
              {this.props.content.ok}
            </button>
          </div>
        </BasicModal>
      );
    }
  }

  closeAlertModal() {
    ReactDOM.findDOMNode(this.refs.potName).focus();
    if (this.state.errorModal) {
      SavingPotsActionCreator.closetErrorModal();
    }
    this.setState({
      isDuplicateModal: false,
      errorModal: false,
      isChanged: true,
      isLoader: false,
    });
  }

  decrement() {
    const pot = _.extend({}, this.state.pots);
    const potBalance = parseFloat(
      this.state.potBalanceValue.replace(/[^\d.]*/g, '')
    );
    let potScheduleValue = this.state.pots.schedule.recurrence.amount.value;
    if (!_.isNumber(potScheduleValue)) {
      potScheduleValue = parseFloat(potScheduleValue.replace(/[^\d.]*/g, ''));
    }
    if (_.isNaN(potScheduleValue)) {
      potScheduleValue = 0;
    }
    const roundOffValue = potScheduleValue % 10;
    if (roundOffValue !== 0) {
      pot.schedule.recurrence.amount.value = `£${
        potScheduleValue - roundOffValue
      }`;
    } else {
      if (potScheduleValue <= 0) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue}`;
      } else if (potScheduleValue > 0 && potScheduleValue <= 500) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue - 10}`;
      } else if (potScheduleValue > 500 && potScheduleValue <= 990) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue - 50}`;
      } else if (potScheduleValue >= 1000 && potScheduleValue <= 10000) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue - 100}`;
      } else {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue - 1000}`;
      }
    }
    this.setState({ pots: pot, isChanged: true, isLoader: false }, () => {
      this.handlePotScheduleValueBlur();
      const potScheduleValue = Number(
        pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
      );
      let potValue;
      if (!_.isNumber(pot.goal.amount.value)) {
        potValue = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
      } else {
        potValue = Number(pot.goal.amount.value);
      }
      if (
        (this.props.potDetailsData &&
          potScheduleValue === this.props.potDetailsData.monthlyContry) ||
        potScheduleValue === 0 ||
        potValue === 0 ||
        potValue < potBalance
      ) {
        this.setState({ isDisabledSubmit: true, isCreatePot: 'fade' });
      } else {
        this.setState({ isDisabledSubmit: false, isCreatePot: 'fade in' });
      }
    });
    if (potScheduleValue <= 10) {
      this.setState({ isDisabledDecrease: true });
    }
  }

  getAccountNumber() {
    const seletedAccountData = AccountsStore.getAccountDetail(
      this.props.getSelectedAccountID
    );
    const accountNumber = _.last(_.split(seletedAccountData.number, '-'));
    return accountNumber;
  }

  getCurrentPotPage() {
    SavingPotsActionCreator.getPotDetail(this.state.potID);
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description:
          config.analytics.analytics_action_saving_goal_edit_cancel_edit_goal,
        event: 'click',
      }
    );
  }

  getExpectedMonth() {
    let goalValue;
    if (_.isNumber(this.state.pots.goal.amount.value)) {
      goalValue = this.state.pots.goal.amount.value;
    } else {
      goalValue = Number(
        this.state.pots.goal.amount.value.replace(/[^\d.]*/g, '')
      );
    }
    if (_.isNaN(goalValue)) {
      goalValue = 0;
    }
    let balanceValue = parseFloat(
      this.state.potBalanceValue.replace(/[^\d.]*/g, '')
    );
    if (_.isNaN(balanceValue)) {
      balanceValue = 0;
    }
    let monthlyCotribution;
    if (_.isNumber(this.state.pots.schedule.recurrence.amount.value)) {
      monthlyCotribution = this.state.pots.schedule.recurrence.amount.value;
    } else {
      monthlyCotribution = Number(
        this.state.pots.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
      );
    }
    if (_.isNaN(monthlyCotribution)) {
      monthlyCotribution = 0;
    }
    let newTargetAmountValue = goalValue - balanceValue;
    let totalMonths;
    if (
      newTargetAmountValue === monthlyCotribution ||
      goalValue === 0 ||
      monthlyCotribution === 0
    ) {
      totalMonths = 0;
    } else {
      const totalTimeRequired = newTargetAmountValue / monthlyCotribution;
      totalMonths = Math.ceil(totalTimeRequired);
      if (totalMonths * monthlyCotribution >= newTargetAmountValue) {
        totalMonths = totalMonths - 1;
      }
    }
    let expectedMonths;
    if (goalValue === 0 || totalMonths === 0 || totalMonths < 0) {
      expectedMonths = moment().date(1).format('YYYY-MM-DD');
    } else {
      expectedMonths = moment()
        .add(totalMonths, 'months')
        .date(1)
        .format('YYYY-MM-DD');
    }
    return expectedMonths;
  }

  getExpectedScheduleValue() {
    const selectedMonth = moment(
      moment(this.state.pots.goal.when).format('YYYY-MM')
    );
    const currentMonth = moment(moment().format('YYYY-MM'));
    const monthDiff = selectedMonth.diff(currentMonth, 'months') + 1;
    let goalValue;
    if (_.isNumber(this.state.pots.goal.amount.value)) {
      goalValue = this.state.pots.goal.amount.value;
    } else {
      goalValue = parseFloat(
        this.state.pots.goal.amount.value.replace(/[^\d.]*/g, '')
      );
    }
    if (_.isNaN(goalValue)) {
      goalValue = 0;
    }
    let balanceValue = parseFloat(
      this.state.potBalanceValue.replace(/[^\d.]*/g, '')
    );
    if (_.isNaN(balanceValue)) {
      balanceValue = 0;
    }
    let monthlyCotribution;
    if (goalValue === 0) {
      monthlyCotribution = '£';
    } else {
      let calcContribution = (goalValue - balanceValue) / monthDiff;
      if (_.isInteger(calcContribution)) {
        monthlyCotribution = calcContribution.toFixed(0);
      } else {
        calcContribution = calcContribution * 100;
        calcContribution = Math.ceil(calcContribution) / 100;
        monthlyCotribution = calcContribution.toFixed(2);
      }
    }
    return monthlyCotribution;
  }

  handleDateChange(newDate) {
    currentDateFlag = true;
    const pot = _.extend({}, this.state.pots);
    pot.goal.when = newDate;
    let potGoalValue;
    if (_.isString(pot.goal.amount.value)) {
      potGoalValue = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
    } else {
      potGoalValue = Number(pot.goal.amount.value);
    }
    this.setState({ pots: pot, isLoader: false }, () => {
      let potScheduleRefAmount;
      if (_.isNumber(this.state.pots.schedule.recurrence.amount.value)) {
        potScheduleRefAmount = parseFloat(
          this.state.pots.schedule.recurrence.amount.value
        );
      } else {
        potScheduleRefAmount = parseFloat(
          this.state.pots.schedule.recurrence.amount.value.replace(
            /[^\d.]*/g,
            ''
          )
        );
      }
      if (potScheduleRefAmount === 0 || _.isNaN(potScheduleRefAmount)) {
        const putaway = _.extend({}, this.state.pots);
        const putAwayValue = this.getExpectedScheduleValue();
        if (putAwayValue > 0) {
          putaway.schedule.recurrence.amount.value = `£${this.getExpectedScheduleValue()}`;
          if (potGoalValue > 0) {
            this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
          }
          this.setState({
            pots: putaway,
            isDisabledDecrease: false,
            isChanged: true,
          });
        }
      }
    });
    if (this.props.potDetailsData) {
      this.setState({
        isDisabledSubmit: false,
        isCreatePot: 'fade in',
        isLoader: false,
      });
    }
  }

  handlePotBalanceChange(e) {
    const pot = _.extend({}, this.state.pots);
    let goalAmt;
    if (_.isNumber(pot.goal.amount.value)) {
      goalAmt = pot.goal.amount.value;
    } else {
      goalAmt = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
    }
    const isValid = this.checkNumberForBalance(e.target.value);
    const eTargetValue = e.target.value;
    let etarget;
    this.setState({ isBalanceShaked: '', isLoader: false });
    if (isValid) {
      etarget = e.target.value.replace(/[^\d.]*/g, '');
      if (etarget === '') {
        this.setState({ potBalanceValue: '£' });
      } else if (etarget === '.' || etarget === '0.') {
        this.setState({ potBalanceValue: '£0.' }, () => {
          if (eTargetValue !== this.state.potBalanceValue) {
            this.setState({ isBalanceShaked: 'animated shake' });
          } else {
            this.setState({ isBalanceShaked: '' });
          }
        });
      } else if (etarget === '0.0') {
        this.setState({ potBalanceValue: '£0.0' }, () => {
          if (eTargetValue !== this.state.potBalanceValue) {
            this.setState({ isBalanceShaked: 'animated shake' });
          } else {
            this.setState({ isBalanceShaked: '' });
          }
        });
      } else if (etarget === '0.00') {
        this.setState({ potBalanceValue: '£0.00' }, () => {
          if (eTargetValue !== this.state.potBalanceValue) {
            this.setState({ isBalanceShaked: 'animated shake' });
          } else {
            this.setState({ isBalanceShaked: '' });
          }
        });
      } else if (Number(etarget) === 0) {
        this.setState({ potBalanceValue: '£0' }, () => {
          if (eTargetValue !== this.state.potBalanceValue) {
            this.setState({ isBalanceShaked: 'animated shake' });
          } else {
            this.setState({ isBalanceShaked: '' });
          }
        });
      } else {
        this.setState({ potBalanceValue: `£${etarget}` }, () => {
          if (eTargetValue !== this.state.potBalanceValue) {
            this.setState({ isBalanceShaked: 'animated shake' });
          } else {
            this.setState({ isBalanceShaked: '' });
          }
        });
      }
      let potScheduleValue;
      let goalAmtVar = goalAmt;
      let eTargetValueVar = Number(eTargetValue.replace(/[^\d.]*/g, ''));
      if (_.isNumber(pot.schedule.recurrence.amount.value)) {
        potScheduleValue = pot.schedule.recurrence.amount.value;
      } else {
        potScheduleValue = Number(
          pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
        );
      }
      if (
        goalAmt === 0 ||
        potScheduleValue === 0 ||
        goalAmtVar < eTargetValueVar
      ) {
        this.setState({ isDisabledSubmit: true, isCreatePot: 'fade' });
      } else {
        if (!this.props.potDetailsData) {
          this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
        }
      }
    } else {
      this.setState({ isBalanceShaked: 'animated shake', isLoader: false });
    }
  }

  handlePotGoalBlur() {
    let goalAmt;
    let setStateVar = false;
    const pot = _.extend({}, this.state.pots);
    if (_.isNumber(pot.goal.amount.value)) {
      goalAmt = pot.goal.amount.value;
    } else {
      goalAmt = pot.goal.amount.value.replace(/[^\d.]*/g, '');
    }
    if (
      goalAmt !== '£' &&
      goalAmt !== '' &&
      this.state.potBalanceValue !== '' &&
      this.state.pots.goal.when !== moment().format('YYYY-MM-DD')
    ) {
      if (
        pot.schedule.recurrence.amount.value === '£' ||
        pot.schedule.recurrence.amount.value === ''
      ) {
        pot.schedule.recurrence.amount.value = `£${this.getExpectedScheduleValue()}`;
        this.setState({ pots: pot });
      }
      setStateVar = true;
    } else if (this.state.pots.goal.when === moment().format('YYYY-MM-DD')) {
      if (goalAmt !== '' && this.state.isChanged && !currentDateFlag) {
        pot.goal.when = moment(this.getExpectedMonth()).format('YYYY-MM-DD');
        pot.schedule.recurrence.amount.value = `£${this.getExpectedScheduleValue()}`;
        setStateVar = true;
      } else if (
        !currentDateFlag &&
        goalAmt !== '' &&
        pot.schedule.recurrence.amount.value !== '' &&
        pot.schedule.recurrence.amount.value !== '£'
      ) {
        pot.goal.when = moment(this.getExpectedMonth()).format('YYYY-MM-DD');
        setStateVar = true;
      } else if (
        (currentDateFlag && pot.schedule.recurrence.amount.value === '£') ||
        pot.schedule.recurrence.amount.value === ''
      ) {
        pot.schedule.recurrence.amount.value = `£${this.getExpectedScheduleValue()}`;
        setStateVar = true;
      } else if (
        goalAmt !== '' &&
        currentDateFlag &&
        pot.schedule.recurrence.amount.value !== ''
      ) {
        this.setState({
          isChanged: true,
        });
      }
    }
    if (setStateVar) {
      this.setState({
        pots: pot,
        isChanged: true,
        isDisabledDecrease: false,
        isLoader: false,
        isDisabledSubmit: false,
        isCreatePot: 'fade in',
      });
    }
  }

  handlePotGoalChange(e) {
    const pot = _.extend({}, this.state.pots);
    const isValid = this.checkNumber(e.target.value);
    let buttonFlag;
    if (_.isString(pot.schedule.recurrence.amount.value)) {
      buttonFlag = pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '');
    } else {
      buttonFlag = pot.schedule.recurrence.amount.value;
    }
    let potBalance;
    if (_.isNumber(this.state.potBalanceValue)) {
      potBalance = parseFloat(this.state.potBalanceValue);
    } else {
      potBalance = parseFloat(
        this.state.potBalanceValue.replace(/[^\d.]*/g, '')
      );
    }
    const eTargetValue = e.target.value;
    let etarget;
    this.setState({ isGoalShaked: '', isLoader: false });
    if (isValid) {
      etarget = e.target.value.replace(/[^\d.]*/g, '');
      if (this.props.potDetailsData) {
        if (Number(etarget) < Number(potBalance)) {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        } else if (
          Number(etarget) !== Number(this.state.potGoalForEditPot) ||
          Number(buttonFlag) !==
            Number(this.state.potMonthlyContributionForEditPot)
        ) {
          this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
        } else {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        }
      }
      if (etarget === '') {
        pot.goal.amount.value = '£';
      } else if (etarget === '.' || etarget === '0.') {
        pot.goal.amount.value = '£0.';
      } else if (etarget === '0.0') {
        pot.goal.amount.value = '£0.0';
      } else if (etarget === '0.00') {
        pot.goal.amount.value = '£0.00';
      } else if (Number(etarget) === 0) {
        pot.goal.amount.value = '£0';
      } else {
        pot.goal.amount.value = `£${etarget}`;
      }
      this.setState({ pots: pot, isLoader: false }, () => {
        if (eTargetValue !== pot.goal.amount.value) {
          this.setState({ isGoalShaked: 'animated shake' });
        } else {
          this.setState({ isGoalShaked: '' });
        }
        let potValue;
        if (_.isNumber(pot.goal.amount.value)) {
          potValue = pot.goal.amount.value;
        } else {
          potValue = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
        }
        let potScheduleValue;
        if (_.isNumber(pot.schedule.recurrence.amount.value)) {
          potScheduleValue = pot.schedule.recurrence.amount.value;
        } else {
          potScheduleValue = Number(
            pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
          );
        }
        if (potValue === 0 || potScheduleValue === 0 || etarget < potBalance) {
          this.setState({ isDisabledSubmit: true, isCreatePot: 'fade' });
        } else {
          if (!this.props.potDetailsData) {
            this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
          }
        }
      });
    } else {
      this.setState({ isGoalShaked: 'animated shake', isLoader: false });
      if (this.props.potDetailsData) {
        etarget = e.target.value.replace(/[^\d.]*/g, '');
        if (
          Number(etarget) !== Number(this.state.potGoalForEditPot) ||
          Number(buttonFlag) !==
            Number(this.state.potMonthlyContributionForEditPot)
        ) {
          this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
        } else {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        }
      } else {
        this.setState({ isDisabled: false });
      }
    }
  }

  handlePotNameChange(e) {
    const pot = _.extend({}, this.state.pots);
    pot.name = extractAlphaNum(e.target.value);
    this.setState({ pots: pot, isLoader: false });
  }

  handlePotScheduleValueBlur() {
    const pot = _.extend({}, this.state.pots);
    let monthlyContryCheck;
    if (!_.isNumber(pot.schedule.recurrence.amount.value)) {
      monthlyContryCheck = pot.schedule.recurrence.amount.value.replace(
        /[^\d.]*/g,
        ''
      );
    } else {
      monthlyContryCheck = pot.schedule.recurrence.amount.value;
    }
    if (
      pot.goal.amount.value !== '' &&
      pot.goal.amount.value !== '£' &&
      monthlyContryCheck &&
      this.state.pots.goal.when === moment().format('YYYY-MM-DD') &&
      !currentDateFlag
    ) {
      pot.goal.when = moment(this.getExpectedMonth()).format('YYYY-MM-DD');
      this.setState({ pots: pot, isChanged: true, isLoader: false });
    }
  }

  handlePotScheduleValueChange(e) {
    const pot = _.extend({}, this.state.pots);
    const isValid = this.checkNumber(e.target.value);
    let buttonFlag;
    if (_.isString(pot.goal.amount.value)) {
      buttonFlag = pot.goal.amount.value.replace(/[^\d.]*/g, '');
    } else {
      buttonFlag = pot.goal.amount.value;
    }
    const eTargetValue = e.target.value;
    const potBalance = parseFloat(
      this.state.potBalanceValue.replace(/[^\d.]*/g, '')
    );
    let etarget;
    this.setState({ isMonthlyContributionShaked: '', isLoader: false });
    if (isValid) {
      etarget = e.target.value.replace(/[^\d.]*/g, '');
      if (this.props.potDetailsData) {
        if (Number(potBalance) > Number(buttonFlag)) {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        } else if (
          Number(buttonFlag) !== Number(this.state.potGoalForEditPot) ||
          Number(etarget) !==
            Number(this.state.potMonthlyContributionForEditPot)
        ) {
          this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
        } else {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        }
      }
      if (etarget === '') {
        pot.schedule.recurrence.amount.value = '£';
      } else if (etarget === '0.' || etarget === '.') {
        pot.schedule.recurrence.amount.value = '£0.';
      } else if (etarget === '0.0') {
        pot.schedule.recurrence.amount.value = '£0.0';
      } else if (etarget === '0.00') {
        pot.schedule.recurrence.amount.value = '£0.00';
      } else if (Number(etarget) === 0) {
        pot.schedule.recurrence.amount.value = '£0';
      } else {
        pot.schedule.recurrence.amount.value = `£${etarget}`;
      }
      this.setState({ pots: pot }, () => {
        if (eTargetValue !== pot.schedule.recurrence.amount.value) {
          this.setState({ isMonthlyContributionShaked: 'animated shake' });
        } else {
          this.setState({ isMonthlyContributionShaked: '' });
        }
        const potScheduleValue = Number(
          pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
        );
        let potValue;
        if (_.isNumber(pot.goal.amount.value)) {
          potValue = pot.goal.amount.value;
        } else {
          potValue = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
        }
        if (potScheduleValue === 0 || potValue === 0 || potValue < potBalance) {
          this.setState({ isDisabledSubmit: true, isCreatePot: 'fade' });
        } else {
          if (!this.props.potDetailsData) {
            this.setState({ isDisabledSubmit: false, isCreatePot: 'fade in' });
          }
        }
      });
      if (Number(etarget) > 10) {
        this.setState({ isDisabledDecrease: false });
      }
    } else {
      this.setState({
        isMonthlyContributionShaked: 'animated shake',
        isLoader: false,
      });
      if (this.props.potDetailsData) {
        etarget = e.target.value.replace(/[^\d.]*/g, '');
        if (Number(potBalance) > Number(buttonFlag)) {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        } else if (
          Number(buttonFlag) !== Number(this.state.potGoalForEditPot) ||
          Number(etarget) !==
            Number(this.state.potMonthlyContributionForEditPot)
        ) {
          this.setState({ isCreatePot: 'fade in', isDisabledSubmit: false });
        } else {
          this.setState({ isCreatePot: 'fade', isDisabledSubmit: true });
        }
      } else {
        this.setState({ isDisabled: false });
      }
    }
    if (Number(etarget) > 10) {
      this.setState({ isDisabledDecrease: false });
    }
  }

  increment() {
    const pot = _.extend({}, this.state.pots);
    const potBalance = parseFloat(
      this.state.potBalanceValue.replace(/[^\d.]*/g, '')
    );
    let potScheduleValue = this.state.pots.schedule.recurrence.amount.value;
    if (!_.isNumber(potScheduleValue)) {
      potScheduleValue = parseFloat(potScheduleValue.replace(/[^\d.]*/g, ''));
    }
    if (_.isNaN(potScheduleValue)) {
      potScheduleValue = 0;
    }
    const roundOffValue = potScheduleValue % 10;
    if (roundOffValue !== 0) {
      const diff = 10 - roundOffValue;
      pot.schedule.recurrence.amount.value = `£${potScheduleValue + diff}`;
    } else {
      if (potScheduleValue >= 0 && potScheduleValue <= 500) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue + 10}`;
      } else if (potScheduleValue > 500 && potScheduleValue <= 990) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue + 50}`;
      } else if (potScheduleValue >= 1000 && potScheduleValue <= 10000) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue + 100}`;
      } else if (potScheduleValue >= 999999) {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue + 0}`;
      } else {
        pot.schedule.recurrence.amount.value = `£${potScheduleValue + 1000}`;
      }
    }
    this.setState(
      {
        pots: pot,
        isDisabledDecrease: false,
        isChanged: true,
        isLoader: false,
      },
      () => {
        this.handlePotScheduleValueBlur();
        const potScheduleValue = Number(
          pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
        );
        let potValue;
        if (!_.isNumber(pot.goal.amount.value)) {
          potValue = Number(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
        } else {
          potValue = Number(pot.goal.amount.value);
        }
        if (
          (this.props.potDetailsData &&
            potScheduleValue === this.props.potDetailsData.monthlyContry) ||
          potScheduleValue === 0 ||
          potValue === 0 ||
          potValue < potBalance
        ) {
          this.setState({ isDisabledSubmit: true, isCreatePot: 'fade' });
        } else {
          this.setState({ isDisabledSubmit: false, isCreatePot: 'fade in' });
        }
      }
    );
  }

  onBalanceKeyDown() {
    this.setState({ isBalanceShaked: '', isLoader: false });
  }

  onKeyDown() {
    this.setState({ isGoalShaked: '', isLoader: false });
  }

  onMonthlyContributionKeyDown() {
    this.setState({ isMonthlyContributionShaked: '', isLoader: false });
  }

  onPaste(e) {
    e.preventDefault();
  }

  onSave(e) {
    e.preventDefault();
    const pot = _.extend({}, this.state.pots);
    if (_.isNumber(this.state.pots.goal.amount.value)) {
      pot.goal.amount.value = parseFloat(this.state.pots.goal.amount.value);
    } else {
      pot.goal.amount.value = parseFloat(
        this.state.pots.goal.amount.value.replace(/[^\d.]*/g, '')
      );
    }
    if (_.isNaN(pot.goal.amount.value)) {
      pot.goal.amount.value = 0;
    }
    if (_.isNumber(this.state.pots.schedule.recurrence.amount.value)) {
      pot.schedule.recurrence.amount.value = parseFloat(
        this.state.pots.schedule.recurrence.amount.value
      );
    } else {
      pot.schedule.recurrence.amount.value = parseFloat(
        this.state.pots.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
      );
    }
    if (_.isNaN(pot.schedule.recurrence.amount.value)) {
      pot.schedule.recurrence.amount.value = 0;
    }
    SavingPotsActionCreator.getEditedPotData(this.state.potID, pot);
    this.setState({ isLoader: true });
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_edit,
        event: 'click',
      }
    );
  }

  onSubmit(e) {
    e.preventDefault();
    const oldPots = this.props.pots;
    const oldPotName = _.map(oldPots, (item) => _.toUpper(item.name));
    if (_.includes(oldPotName, _.toUpper(this.state.pots.name))) {
      this.setState({ isDuplicateModal: true });
    } else {
      const pot = _.extend({}, this.state.pots);
      if (_.isNumber(this.state.pots.goal.amount.value)) {
        pot.goal.amount.value = parseFloat(this.state.pots.goal.amount.value);
      } else {
        pot.goal.amount.value = parseFloat(
          this.state.pots.goal.amount.value.replace(/[^\d.]*/g, '')
        );
      }
      if (_.isNaN(pot.goal.amount.value)) {
        pot.goal.amount.value = 0;
      }
      if (_.isNumber(this.state.pots.schedule.recurrence.amount.value)) {
        pot.schedule.recurrence.amount.value = parseFloat(
          this.state.pots.schedule.recurrence.amount.value
        );
      } else {
        pot.schedule.recurrence.amount.value = parseFloat(
          this.state.pots.schedule.recurrence.amount.value.replace(
            /[^\d.]*/g,
            ''
          )
        );
      }
      if (_.isNaN(pot.schedule.recurrence.amount.value)) {
        pot.schedule.recurrence.amount.value = 0;
      }
      let potBalance;
      if (_.isNumber(this.state.potBalanceValue)) {
        potBalance = parseFloat(this.state.potBalanceValue);
      } else {
        potBalance = parseFloat(
          this.state.potBalanceValue.replace(/[^\d.]*/g, '')
        );
      }
      if (_.isNaN(potBalance)) {
        SavingsPotsStore.setPotBalanceStoreValue(0);
      } else {
        SavingsPotsStore.setPotBalanceStoreValue(potBalance);
      }
      SavingPotsActionCreator.getPotConfirmation(pot);
      this.setState({ isLoader: true });
    }
    // Record an analytics user event.
    AnalyticsActionCreator.track(
      {
        path: '/user/experience/activity',
        action: 'Interacted',
      },
      {
        description: config.analytics.analytics_name_saving_goal_create,
        event: 'click',
      }
    );
  }

  checkNumber(e) {
    const etarget = e.replace(/[^\d.]*/g, '');
    const len = etarget.length;
    const index = etarget.indexOf('.');
    const dots = etarget.split('.').length;
    const beforeDecimalLen = etarget.split('.')[0].length;
    let isValid = true;
    if (
      beforeDecimalLen > 7 ||
      Number(etarget) > 1000000 ||
      etarget === '1000000.'
    ) {
      isValid = false;
    }
    if (dots > 2) {
      isValid = false;
    }
    if (index >= 0) {
      const CharAfterdot = len + 1 - index;
      if (CharAfterdot > 4) {
        isValid = false;
      }
    }
    return isValid;
  }

  checkNumberForBalance(e) {
    const etarget = e.replace(/[^\d.]*/g, '');
    const len = etarget.length;
    const index = etarget.indexOf('.');
    const dots = etarget.split('.').length;
    const beforeDecimalLen = etarget.split('.')[0].length;
    let isValid = true;
    let goalAmountValue;
    if (_.isNumber(this.state.pots.goal.amount.value)) {
      goalAmountValue = this.state.pots.goal.amount.value;
    } else {
      goalAmountValue = this.state.pots.goal.amount.value.replace(
        /[^\d.]*/g,
        ''
      );
    }
    let goalValueString = goalAmountValue;
    if (goalValueString === '') {
      goalValueString = 0;
    }
    const goalValue = parseFloat(goalValueString);
    if (goalAmountValue !== '') {
      if (Number(etarget) > goalValue) {
        isValid = false;
      }
    }
    if (
      beforeDecimalLen > 7 ||
      Number(etarget) > 1000000 ||
      etarget === '1000000.'
    ) {
      isValid = false;
    }
    if (dots > 2) {
      isValid = false;
    }
    if (index >= 0) {
      const CharAfterdot = len + 1 - index;
      if (CharAfterdot > 4) {
        isValid = false;
      }
    }
    return isValid;
  }

  closeFaq() {
    this.setState({ faqFlag: false });
  }

  openFaq() {
    this.setState({ faqFlag: true });
  }

  render() {
    let headerInRender;
    let content = this.props.content;
    const pot = this.state.pots;
    let goalValue;
    let potScheduleValue;
    let formSubmitButton;
    let formSubmitButtonMobile;
    let headerCancelButton;
    let kitItOffLabel;
    let editClass;
    if (this.props.potDetailsData) {
      kitItOffLabel = content.savingpotcreationcolumn6;
      editClass = 'savingPot__edit';
    } else {
      kitItOffLabel = content.savingpotcreationcolumn2;
    }

    if (_.isString(pot.goal.amount.value)) {
      goalValue = parseFloat(pot.goal.amount.value.replace(/[^\d.]*/g, ''));
      if (_.isNaN(goalValue)) {
        goalValue = 0;
      }
    } else {
      goalValue = parseFloat(pot.goal.amount.value);
    }

    let potBalance;
    if (_.isString(this.state.potBalanceValue)) {
      potBalance = parseFloat(
        this.state.potBalanceValue.replace(/[^\d.]*/g, '')
      );
      if (_.isNaN(potBalance)) {
        potBalance = 0;
      }
    }
    if (_.isString(pot.schedule.recurrence.amount.value)) {
      potScheduleValue = parseFloat(
        pot.schedule.recurrence.amount.value.replace(/[^\d.]*/g, '')
      );
      if (_.isNaN(potScheduleValue)) {
        potScheduleValue = 0;
      }
    } else {
      potScheduleValue = parseFloat(pot.schedule.recurrence.amount.value);
    }

    if (!this.props.potDetailsData) {
      headerCancelButton = (
        <button
          className="page-options opt-green"
          onClick={this.props.getPotPageHandleClick}
        >
          {content.savingsPotCancelButton}
        </button>
      );
      if (!this.state.isDisabledSubmit) {
        if (BrowserUtils.isMobileView()) {
          formSubmitButtonMobile = (
            <button className="page-options opt-green" onClick={this.onSubmit}>
              {content.savingDone}
            </button>
          );
        } else {
          formSubmitButton = (
            <div className={`form-footer  ${this.state.isCreatePot}`}>
              <button
                type="button"
                className="create-pot-button action-button"
                onClick={this.onSubmit}
              >
                {' '}
                {content.savingPotCreatePotButton}{' '}
              </button>
            </div>
          );
        }
      }
    } else {
      if (BrowserUtils.isMobileView()) {
        headerCancelButton = (
          <button
            className="page-options opt-green"
            onClick={this.props.getPotPageHandleClick}
          >
            {content.savingsPotCancelButton}
          </button>
        );
      } else {
        headerCancelButton = (
          <button
            className="page-back opt-green"
            onClick={this.getCurrentPotPage}
          >
            <span className="icon icon-page-back" /> {content.back}
          </button>
        );
      }
      if (!this.state.isDisabledSubmit) {
        if (BrowserUtils.isMobileView()) {
          formSubmitButtonMobile = (
            <button className="page-options" onClick={this.onSave}>
              {this.props.content.savingDone}
            </button>
          );
        } else {
          formSubmitButton = (
            <div className={`form-footer  ${this.state.isCreatePot}`}>
              <button
                type="button"
                className="create-pot-button action-button"
                onClick={this.onSave}
              >
                {' '}
                {content.savingPotConfirmChangeButton}{' '}
              </button>
            </div>
          );
        }
      }
    }

    let goalAmount = pot.goal.amount.value;
    if (_.isNumber(goalAmount)) {
      goalAmount = `£${goalAmount}`;
    }
    let balanceAmount = this.state.potBalanceValue;
    if (_.isNumber(balanceAmount)) {
      balanceAmount = `£${balanceAmount}`;
    }
    let monthlyAmount = pot.schedule.recurrence.amount.value;
    if (_.isNumber(monthlyAmount)) {
      monthlyAmount = `£${monthlyAmount}`;
    }
    if (BrowserUtils.isMobileView()) {
      headerInRender = (
        <div className="savingpot_component__header--title">
          {this.state.headerMessage}
        </div>
      );
    } else {
      headerInRender = (
        <div className="savingpot_component__header--title">
          {this.state.headerMessage} {this.state.accountNumber}
        </div>
      );
    }
    if (!this.state.isLoader) {
      let fromTop = '';
      if (BrowserUtils.isMobileView()) {
        fromTop = 'from-top';
      }
      return (
        <div className={`main-container ${fromTop}`}>
          {this.alertOnDuplicatePotName()}
          {this.alertEditErrorModal()}
          <div
            className={`savingPot__create ${this.props.accountClass} ${editClass}`}
          >
            <div className="savingpot_component__header row no-gutters">
              <div className="col-xs-3 text-left">{headerCancelButton}</div>
              <div className="col-xs-6 text-center">{headerInRender}</div>
              <div className="col-xs-3 text-right">
                {formSubmitButtonMobile}
              </div>
            </div>

            <form action="" className="form-horizontal">
              <div className="savingPot__create--component">
                <div className="create--form">
                  <div className="create--form--box">
                    <div className="form-group potName">
                      <label htmlFor="potName" className="sr-only">
                        {content.savingsPotNameLabel}
                      </label>
                      <input
                        autoComplete="off"
                        type="text"
                        autoFocus
                        id="potName"
                        ref="potName"
                        value={pot.name}
                        disabled={this.state.isNameDisabled}
                        placeholder={content.savingsPotNameLabel}
                        onChange={this.handlePotNameChange}
                        maxLength="17"
                        onPaste={this.onPaste}
                      />
                    </div>

                    <div className="form-group row no-gutters">
                      <label
                        htmlFor="potGoal"
                        className="col-xs-8 control-label"
                      >
                        {content.savingpotcreationcolumn1}
                      </label>
                      <div className="col-xs-4">
                        <input
                          autoComplete="off"
                          type="text"
                          value={goalAmount}
                          className={`form-control ${this.state.isGoalShaked}`}
                          id="potGoal"
                          placeholder=""
                          onChange={this.handlePotGoalChange}
                          onBlur={this.handlePotGoalBlur}
                          onKeyDown={this.onKeyDown}
                          onPaste={this.onPaste}
                        />
                      </div>
                    </div>

                    <div className="form-group row no-gutters">
                      <label
                        htmlFor="potBalance"
                        className="col-xs-8 control-label"
                      >
                        {kitItOffLabel}
                      </label>
                      <div className="col-xs-4 text-right">
                        <input
                          autoComplete="off"
                          type="text"
                          value={balanceAmount}
                          className={`form-control ${this.state.isBalanceShaked}`}
                          id="potBalance"
                          placeholder=""
                          disabled={this.state.isCurrentBalanceDisabled}
                          onChange={this.handlePotBalanceChange}
                          onKeyDown={this.onBalanceKeyDown}
                          onPaste={this.onPaste}
                        />
                      </div>
                    </div>

                    <div className="form-group row no-gutters">
                      <label
                        htmlFor="potGoalDate"
                        className="col-xs-6 control-label"
                      >
                        {content.savingpotcreationcolumn3}
                      </label>
                      <div className="col-xs-6 date-timePicker">
                        <SavingPotDatePicker
                          minDate={this.state.startMinDate}
                          dateTime={pot.goal.when}
                          format={this.state.format}
                          viewMode={this.state.mode}
                          inputFormat={this.state.inputFormat}
                          onChange={this.handleDateChange}
                          defaultText={this.state.defaultText}
                        />
                      </div>
                    </div>

                    <div className="form-group row no-gutters align-items-center">
                      <label
                        htmlFor="potScheduleValue"
                        className="col-lg-7 col-md-7 col-sm-7 col-xs-5 control-label"
                      >
                        {content.savingpotcreationcolumn4}
                      </label>
                      <div className="col-lg-5 col-md-5 col-sm-5 col-xs-7">
                        <div className="numberAdjust">
                          <input
                            autoComplete="off"
                            type="text"
                            value={monthlyAmount}
                            className={`form-control ${this.state.isMonthlyContributionShaked}`}
                            id="potScheduleValue"
                            onChange={this.handlePotScheduleValueChange}
                            onBlur={this.handlePotScheduleValueBlur}
                            onKeyDown={this.onMonthlyContributionKeyDown}
                            onPaste={this.onPaste}
                          />
                          <div className="btn-numberAdjust">
                            <button
                              onClick={this.decrement}
                              type="button"
                              disabled={this.state.isDisabledDecrease}
                            >
                              <img
                                src="../images/b/icons/remove.svg"
                                height="15"
                                alt=""
                              />
                            </button>
                            <button onClick={this.increment} type="button">
                              <img
                                src="../images/b/icons/add.svg"
                                height="15"
                                alt=""
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="create--messages">
                  <div className="potMessages">
                    <PotMessages
                      amountvalue={potScheduleValue}
                      goal={goalValue}
                      goalwhen={pot.goal.when}
                      balance={potBalance}
                      content={content}
                      isChanged={this.state.isChanged}
                    />
                  </div>
                  <img src="../images/b/savings-pots-pig.png" alt="" title="" />
                </div>
              </div>
              {formSubmitButton}
            </form>
          </div>
        </div>
      );
    } else {
      return (
        <div>
          <div className="main-container">
            {/* <div className="spinner-loader fade in">
						<div className="spinner">
							<SvgIcon id="icon-refresh" width="200px" height="200px"/>
						</div>
					</div> */}
            <LoaderComponent type="large" />
          </div>
        </div>
      );
    }
  }
}

CreateSavingsPot.propTypes = {
  potDetailsData: PropTypes.object,
  pots: PropTypes.array,
  content: PropTypes.object,
  getPotPageHandleClick: PropTypes.func,
  getSelectedAccountID: PropTypes.string,
  accountClass: PropTypes.string,
  editError: PropTypes.object,
};

export { CreateSavingsPot };
